import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button} from "react-bootstrap";
import APICom from "../../../../utils/helpers/APICom";
import ConfirmationModal from "../../../Controls/ConfirmationModal";



const PickedUp = (props) => {

    const { loginData } = useSelector((store) => store.login);
    const { ASCSSettingData, BrokerServingAffiliatesData }  = useSelector((store) => store.combinedata);
    const [ showPickedUpAlert, setPickedUpAlert] = useState(false);
    const [ pickedupAlertObj, setPickedupAlertObj] = useState({alertTitle: '', alertMsg:''});
    const [ dispatchMethod, setDispatchMethod] = useState(0);
    const [ allowableTimeTripActions, setAllowableTimeTripActions] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [modalBodyText, setModalBodyText] = useState('');


    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        UnMountPickedUpComponent()

    };
    const handleOkModal = () => {
        setShowModal(false);
        PerformManualPickedUp();

    };

    useEffect(() => {
        
        if(props.GridRowData === null || props.GridRowData.length <= 0)
        {
            setPickedupAlertObj({...pickedupAlertObj, alertTitle: 'No trip selected', alertMsg:'No request selected to perform PICKEDUP.'});
            setPickedUpAlert(true);
        }
        else
        {
            const gData = props.GridRowData[0];
            let filteredAffiliates = [];
            try{
              filteredAffiliates = BrokerServingAffiliatesData?.filter(
                  (aff) => String(aff.iBrokerAffiliateID) === String(gData.iSRATSPID)
              );
            }
            catch(e){
              
            }
            if(filteredAffiliates?.length > 0)
            {
                setPickedupAlertObj({...pickedupAlertObj, alertTitle: 'Action Restriction', alertMsg: "Action is not allowed for external trip."});
                setPickedUpAlert(true);
            }
            else if(gData.iServiceStatusID !== "3")
            {
                setPickedupAlertObj({...pickedupAlertObj, alertTitle: 'Invalid Action', alertMsg: "Action not allowed on un-dispatched trip."});
                setPickedUpAlert(true);
            }
            else if(gData.TripRequestStatus.toLowerCase() === "cancelled")
            {
                setPickedupAlertObj({...pickedupAlertObj, alertTitle: 'Invalid Action', alertMsg: "Cannot perform Pickedup action on 'CANCELLED' trip."});
                setPickedUpAlert(true);
            }
            else if(gData.TripRequestStatus.toLowerCase() === "pickedup" || gData.TripRequestStatus.toLowerCase() === "dropped")
            {
                setPickedupAlertObj({...pickedupAlertObj, alertTitle: 'Invalid Action', alertMsg: "Request '" + gData.ConfirmationNo + "' is already '" + gData.TripRequestStatus + "'."});
                setPickedUpAlert(true);
            }
            else if(gData.TripRequestStatus.toLowerCase() === "atlocation")
            {
                if(ASCSSettingData !== null && ASCSSettingData !== undefined)
                {
                    if (ASCSSettingData.hasOwnProperty(props.GridRowData[0].iSRATSPID)) {
                        const ascsSettingDataByAffiliate = JSON.parse(ASCSSettingData[props.GridRowData[0].iSRATSPID]); // Parse JSON string into an array
                        for(let i=0; i < ascsSettingDataByAffiliate.length; i++)
                        {
                            if(ascsSettingDataByAffiliate[i]["SubTitle"] === "DispatchMethod")
                            {
                                setDispatchMethod(ascsSettingDataByAffiliate[i]["value"]);
                            }

                            if(ascsSettingDataByAffiliate[i]["SubTitle"] === "AllowableTimeTripActions")
                            {
                                setAllowableTimeTripActions(ascsSettingDataByAffiliate[i]["value"]);
                            }
                        }
                    }
                }
                let pickUpDateTimeObj = new Date(props.GridRowData[0].PickupDateTime)
                pickUpDateTimeObj.setMinutes(pickUpDateTimeObj.getMinutes() - parseInt(allowableTimeTripActions, 10));

                let minimumPickDateTimeObj = new Date(pickUpDateTimeObj)
                let currentDateTime = new Date();

                let timeDifference =  currentDateTime - minimumPickDateTimeObj
                let differenceInMinutes = Math.floor(Math.abs(timeDifference) / (1000 * 60));

                if (currentDateTime < minimumPickDateTimeObj) {
                    let message = ''
                    if (differenceInMinutes > 60) {
                        let hours = Math.floor(differenceInMinutes / 60);
                        let minutes = differenceInMinutes % 60;
                        message = `This trip is scheduled to be picked-up in over ${hours} hours and ${minutes} minutes. Marking it as 'Picked Up' seems too early. Do you want to continue?`;
                    } else {
                        message = `This trip is scheduled to be picked-up in over ${differenceInMinutes} minutes. Marking it as 'Picked Up' seems too early. Do you want to continue?`;
                    }
                    setModalBodyText(message)
                    handleShowModal()
                } else {
                    PerformManualPickedUp()
                }
            }
            else
            {
                setPickedupAlertObj({...pickedupAlertObj, alertTitle: 'Action Restriction', alertMsg: "'" + gData.ConfirmationNo + "' cannot be marked as Picked Up. Trip state is not AT-Location."});
                setPickedUpAlert(true);
            }
            
                
        }

    }, []);


    const PerformManualPickedUp = async () => {
        const gData = props.GridRowData[0];
        var Param = {
          "iServiceID": gData.ServiceID,
          "DispatchedBy": dispatchMethod,
          "iRefID": gData.ConfirmationNo,
          "iUserID": loginData.iUserID
        }
        let response = await APICom.fetchData("", "TripActions/PerformManualPickedUp", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;
        if(result.count > 0)
        {
            setPickedupAlertObj({...pickedupAlertObj, alertTitle: 'PickedUp Action', alertMsg: "Action performed successfully."});
            setPickedUpAlert(true);
            props.GridRowData[0].TripRequestStatus = 'PICKEDUP'
        }
        else
        {
            setPickedupAlertObj({...pickedupAlertObj, alertTitle: 'PickedUp Failed', alertMsg: "Action failed."});
            setPickedUpAlert(true);
        }
        //props.ReloadDataFunction();
    }

    const handlePickedUpAlertClose = () => {
        setPickedUpAlert(false);
        UnMountPickedUpComponent();
      }
    
      const UnMountPickedUpComponent = () => {
        if(props.pickedupComponentLoaded)
        {
          props.setPickedUpProcessing(false);
          props.setPickedUpComponentLoad(false);
        }
      }

    return(
        <>
            { showPickedUpAlert && <Modal centered show={showPickedUpAlert} onHide={handlePickedUpAlertClose} animation={false} >
                                  <Modal.Header className='activate_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                                    <Modal.Title className='activate_dialog_title_color'>{pickedupAlertObj.alertTitle}</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body><b>{pickedupAlertObj.alertMsg}</b></Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" onClick={handlePickedUpAlertClose}>
                                      Close
                                    </Button>
                                  </Modal.Footer>
                                </Modal>}
            {showModal ? <ConfirmationModal show={true}  Title={'Mark Picked Up Warning'}  Body={modalBodyText} btnCanceText={'Cancel'}  btnOkText={'Mark Picked Up'} ShowCancelButton={true} onOk={handleOkModal} onCancel={handleCloseModal} /> : "" }
        </>
    );

};

export default PickedUp;